const strengthCalculator = str => {
    const REGEX_UPPER_CASE = /[A-Z]/;
    const REGEX_LOWER_CASE = /[a-z]/;
    const REGEX_NUMBER = /[0-9]/;
    const REGEX_SPECIAL = /[!"#$%&'()*+,-.\\/:;<=>?@[\]^_`{|}~]/;

    const uppercaseExists = REGEX_UPPER_CASE.test(str);
    const lowercaseExists = REGEX_LOWER_CASE.test(str);
    const numberExists = REGEX_NUMBER.test(str);
    const specialCharExists = REGEX_SPECIAL.test(str);
    const lengthRequirement = str.length >= 8;
    const valid =
        lengthRequirement &&
        uppercaseExists &&
        lowercaseExists &&
        numberExists &&
        specialCharExists;

    return {
        lengthRequirement,
        uppercaseExists,
        lowercaseExists,
        numberExists,
        specialCharExists,
        valid,
    };
};

export default strengthCalculator;
